var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.img}}),_c('p',[_vm._v("未到找指定页面")])])}
var staticRenderFns = []

export { render, staticRenderFns }